import {
  canViewAccountingReport,
  isHensonFundReportEnabled,
} from '@blocktickets/shared-utils'

const reportingPathsFromSections = (sections) =>
  (sections || []).flatMap((section) =>
    (section.reports || []).map((report) => report.path)
  )

const buildReportingMenuSections = ({
  foodAndBeverageEnabled = false,
  orgUuid = '',
  env = 'development',
  canViewAccounting = false,
  canViewPayoutsReport = false,
  paymentPlansEnabled = false,
  isSuperUser = false,
} = {}) =>
  [
    {
      id: 'analytics',
      title: 'Analytics',
      reports: [
        {
          path: '/attendance-intelligence',
          label: 'Attendance Intelligence',
        },
        {
          path: '/comp-intelligence',
          label: 'Complimentary Intelligence',
        },
        {
          path: '/geographic-sales-intelligence',
          label: 'Geographic Sales Intelligence',
        },
        {
          path: '/pricing-level-performance',
          label: 'Pricing Level Performance',
        },
        {
          path: '/sales-velocity',
          label: 'Sales Velocity',
        },
        {
          path: '/weather-event-analytics',
          label: 'Weather Event Analytics',
        },
      ],
    },
    {
      id: 'attendance-access',
      title: 'Attendance & Access',
      reports: [
        {
          path: '/access-control-summary',
          label: 'Access Control Summary',
        },
        {
          path: '/daily-tickets-count',
          label: 'Daily Ticket Counts',
        },
        {
          path: '/time-stamp-report',
          label: 'Time Stamp Report',
        },
      ],
    },
    {
      id: 'sales-revenue',
      title: 'Sales & Revenue',
      reports: [
        {
          path: '/custom-fee-report',
          label: 'Custom Fee Report',
        },
        {
          path: '/daily-settlement',
          label: 'Daily Settlement Report',
        },
        {
          path: '/sales-attendance',
          label: 'Event Sales & Attendance',
        },
        ...(foodAndBeverageEnabled
          ? [
              {
                path: '/fnb-analytics',
                label: 'F&B Analytics',
              },
              {
                path: '/fnb-eod-report',
                label: 'F&B End of Day Report',
              },
            ]
          : []),
        {
          path: '/flex-package-sales-summary',
          label: 'Flex Package Sales Summary',
        },
        ...(isHensonFundReportEnabled(orgUuid)
          ? [
              {
                path: '/henson-fund-report',
                label: 'Henson Fund Report',
              },
              {
                path: '/summary-by-payment-method',
                label: 'Summary by Payment Method',
              },
            ]
          : []),
        {
          path: '/yoy-difference-report',
          label: 'YOY Difference',
        },
      ],
    },
    {
      id: 'orders-receivables',
      title: 'Orders & Receivables',
      reports: [
        {
          path: '/ar-aging-details',
          label: 'A/R Aging Details Report',
        },
        {
          path: '/ar-aging-summary',
          label: 'A/R Aging Summary Report',
        },
        {
          path: '/buyer-types-report',
          label: 'Buyer Types Report',
        },
        {
          path: '/order-listings',
          label: 'Order Listings',
        },
        {
          path: '/promoter-sales-reports',
          label: 'Promoter Sales Reports',
        },
        env !== 'production'
          ? {
              path: '/report-builder',
              label: 'Report Builder',
            }
          : null,
        {
          path: '/sales-receivables-by-category',
          label: 'Sales & Receivables by Category',
        },
        {
          path: '/season-report',
          label: 'Season Report',
        },
      ].filter(Boolean),
    },
    {
      id: 'finance',
      title: 'Finance',
      reports: [
        canViewAccounting
          ? {
              path: '/accounting-report',
              label: 'Accounting',
            }
          : null,
        {
          path: '/flex-pack-deferred-revenue',
          label: 'Flex Pack Deferred Revenue',
        },
        canViewPayoutsReport && paymentPlansEnabled
          ? {
              path: '/payment-plans-report',
              label: 'Payment Plans',
            }
          : null,
        canViewPayoutsReport
          ? {
              path: '/payouts-report',
              label: 'Payouts Report',
            }
          : null,
        {
          path: '/deferred-revenue',
          label: 'Season Deferred Revenue',
        },
      ].filter(Boolean),
    },
    {
      id: 'admin',
      title: 'Admin',
      reports: [
        isSuperUser
          ? {
              path: '/client-report',
              label: 'Client Report',
            }
          : null,
      ].filter(Boolean),
    },
  ].filter((section) => section.reports.length > 0)

const HENSON_FUND_ORG = 'dbeea528-852e-43d0-b607-c8201d7a5f1c'

const everyReportingPath = () =>
  reportingPathsFromSections(
    buildReportingMenuSections({
      foodAndBeverageEnabled: true,
      orgUuid: HENSON_FUND_ORG,
      env: 'development',
      canViewAccounting: true,
      canViewPayoutsReport: true,
      paymentPlansEnabled: true,
      isSuperUser: true,
    })
  )

export {
  buildReportingMenuSections,
  everyReportingPath,
  reportingPathsFromSections,
}
